import { ChangeLogOutputDto } from "./change-log-output-dto.model";

export class BBLogDto {
  tableName = '';
  columnName = '';
  primaryId = 0 ;
  logData : ChangeLogOutputDto[] = [];
}
